<template>
  <div>
    <draggable class="draggable list-group" :list="columns" handle=".js-draggable-handle" @change="handleUpdate">
      <div class="card draggable__item list-group-item" v-for="(column, index) in columns" :key="index">
        <div class="card-header d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-start pr-2">
            <i class="fas fa-ellipsis-v draggable__handle js-draggable-handle"></i>
          </div>

          <button class="btn btn-danger ml-2" @click="removeColumn(index)" type="button">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <media-widget
          :value="column.media.join(',')"
          @update="(media) => {handleColumnUpdate(media, index)}"
          class="mb-2 w-100"
        ></media-widget>

        <div class="d-flex align-items-center w-100 mb-2">
          <input
            class="form-control mr-2"
            type="text"
            name="text"
            v-model="column.title"
            @keyup="handleUpdate"
            placeholder="Titel"
          />
        </div>

        <div class="w-100">
          <ckeditor
            name="text"
            :id="`text-${id}-${index}`"
            v-model="column.content"
            @input="handleUpdate"
          />
        </div>
      </div>
    </draggable>

    <button
      class="btn btn-secondary"
      @click="addColumn"
      type="button"
      :disabled="columns.length === 2"
    >
      Kolom toevoegen
    </button>
  </div>
</template>

<script>
  import draggable from 'vuedraggable';
  import ckeditor from '../../../vendor/ckeditor';
  import MediaWidget from '../../MediaWidget';

  export default {
    components: { draggable, ckeditor, MediaWidget },
    props: ['id', 'field'],

    data() {
      return {
        columns: null,
      };
    },

    created() {
      this.columns = Array.prototype.slice.call(this.field.specification.columns);

      if (typeof this.field.value !== 'undefined' && this.field.value !== '') {
        this.field.value.forEach((column) => {
          this.columns.push(column);
        });
      }
    },

    methods: {
      addColumn() {
        this.columns.push({
          media: [],
          title: '',
          content: '',
        });
      },

      removeColumn(index) {
        this.$delete(this.columns, index);
        this.handleUpdate();
      },

      handleUpdate(ids) {
        this.$emit('field-update', this.field.key, this.columns);
      },

      handleColumnUpdate(media, index) {
        const columns = Array.prototype.slice.call(this.columns);

        columns[index].media = media;

        this.$emit('field-update', this.field.key, columns);
      },
    }
  };
</script>
